import { render, staticRenderFns } from "./brandList.vue?vue&type=template&id=311aecee&scoped=true"
import script from "./brandList.vue?vue&type=script&lang=js"
export * from "./brandList.vue?vue&type=script&lang=js"
import style0 from "./brandList.vue?vue&type=style&index=0&id=311aecee&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311aecee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('311aecee')) {
      api.createRecord('311aecee', component.options)
    } else {
      api.reload('311aecee', component.options)
    }
    module.hot.accept("./brandList.vue?vue&type=template&id=311aecee&scoped=true", function () {
      api.rerender('311aecee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goods/brandList/brandList.vue"
export default component.exports